import {format} from "date-fns";
import { formatDateWithTimezone } from './formatDateWithTimezone';

export const formatDateUTC = (date: string | Date, formatter: 'short' | 'long' = 'short', timezone?: string) => {
  if (timezone) {
    return formatDateWithTimezone(date, timezone, formatter);
  }
  return format(new Date(date), formatter === 'short' ? 'dd/MM/yyyy HH:mm:ss' : 'dd MMM yyyy HH:mm:ss');
};